class TestimonialsSliderElement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.TestimonialsSliderElementElement = this
    this.totalSlides = this.getAttribute('data-total-slides');
    const config = {
      direction: 'horizontal',
      spaceBetween: 40,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.testimonials-slider-pagination',
            clickable: true,
            type: 'bullets'
          }
        },
        768: {
          spaceBetween: 80,
          slidesPerView: 3,
          centeredSlides: false,
          loop: false,
        },
      },
    }

    if (this.totalSlides > 6) {
      config.breakpoints[768].slidesPerGroup = 2;
      config.breakpoints[768].centeredSlides = true;
      config.breakpoints[768].loop = true;
    }

    if (this.totalSlides > 3) {
      config.pagination = {
        el: '.testimonials-slider-pagination',
        clickable: true,
        type: 'bullets',
        clickable: true,
      }
    }

    this.carousel = new Swiper(this.TestimonialsSliderElementElement, config);

    window.addEventListener('resize', () => {
      this.carousel.update();
    });
  }

  disconnectedCallback() {
    
  }
}

if (customElements.get('testimonials-slider') === undefined) {
  customElements.define('testimonials-slider', TestimonialsSliderElement)
}